export function getNotification(state) {
  return state.notification;
}
